export const NOT_INPUT = ' chưa được nhập.';
export const REQUIRED  = ' không hợp lệ.';
export const INCORRECT  = ' đã bị trùng.';
export const SAVE_SUCCESS  = 'Lưu thành công';
export const UPDATE_SUCCESS  = 'Cập nhật thành công';
export const DELETE_SUCCESS  = 'Xóa thành công';
export const SYS_ERROR  = 'Đã xảy ra lỗi hệ thống. Vui lòng liên hệ quản trị viên.';